import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$lte } from '../../utils/query-helpers';

export const MISSING_FIELDS = {
  // Missing activity
  activityId: {
    $null: true
  },
  $or: [
    // Missing description
    {
      interactionDescription: {
        $equals: ''
      }
    },
    {
      interactionDescription: {
        $null: true
      }
    },
    // Missing date
    {
      specificDate: 'Yes',
      date: {
        $null: true
      }
    },
    // Missing date range
    {
      specificDate: 'No',
      $or: {
        startDate: {
          $null: true
        },
        endDate: {
          $null: true
        }
      }
    },
    // Missing a participant
    {
      ...tags_type_count_$lte(TagTypes.Participant, 0),
    },
    // Missing a method of interaction
    {
      ...tags_type_count_$lte(TagTypes.InteractionType, 0),
    }
  ]
}

export const MISSING_FIELDS_$AGGREGATIONS = [
  {
    type: 'count',
    alias: 'numberOfParticipantTags',
    relation: 'tagNodes.tag',
    $where: {
      type: TagTypes.Participant
    }
  },
  {
    type: 'count',
    alias: 'numberOfInteractionTypeTags',
    relation: 'tagNodes.tag',
    $where: {
      type: TagTypes.InteractionType
    }
  }
]

export const MISSING_FIELDS_$HAVING = {
  $or: {
    // Missing activity
    activityId: {
      $null: true
    },
    $or: [
      // Missing description
      {
        interactionDescription: {
          $equals: '',
        }
      },
      {
        interactionDescription: {
          $null: true
        }
      },
      // Missing date
      {
        specificDate: 'Yes',
        date: {
          $null: true
        }
      },
      // Missing date range
      {
        specificDate: 'No',
        $or: {
          startDate: {
            $null: true
          },
          endDate: {
            $null: true
          }
        }
      },
      // Missing a participant
      {
        numberOfParticipantTags: {
          $lte: 0
        }
      },
      // Missing a method of interaction
      {
        numberOfInteractionTypeTags: {
          $lte: 0
        }
      }
    ]
  }
}

export default MISSING_FIELDS;
